import { MainMenu } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import interiorsProductListConfig from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';
import withErrorMessage from 'rangeConfig/shared/widgets/withErrorMessage';
import {
  getBrorAddingRegularInteriorToWallSystemFrameErrorMessage,
  getBrorNoMatchingFramesForDrawersErrorMessage,
  getNoFramesInSceneErrorMessage
} from 'rangeConfig/shared/utils/errorMessages';
import ErrorMessageInline from 'rangeConfig/shared/widgets/ErrorMessageInline';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';
import { CoreApi } from '@inter-ikea-storageone/range';
import {
  hideBrorAddingRegularInteriorToWallSystemFrameErrorMessage,
  hideBrorNoMatchingFramesForDrawersErrorMessage
} from 'rangeConfig/bror/rules/hideMenuRules';
import * as R from 'ramda';
import withCategoryFilter from '../../../shared/widgets/withCategoryFilter';
import { default as Black } from '../../ui/Colors/icons/black.js';
import { default as GreyGreen } from '../../ui/Colors/icons/grey_green.js';
import ChangeColorFilter from 'rangeConfig/shared/widgets/ChangeColorFilter/ChangeColorFilter';

const BlackInteriorSwiper = R.pipe(
  withCategoryFilter(['cabinetsAndShelvesBlack', 'interiors-cabinetsBlack'])
);
const GreyGreenInteriorSwiper = R.pipe(
  withCategoryFilter(['cabinetsAndShelvesGreyGreen', 'interiors-cabinetsGreyGreen'])
);

const widgets = {
  desktop: [
    {
      id: 'error-message-no-frames-in-scene',
      component: withErrorMessage(getNoFramesInSceneErrorMessage)(ErrorMessageInline),
      hidden: (coreApi: CoreApi) => hideNoFramesInSceneErrorMessage(coreApi)
    },
    {
      id: 'error-message-only-wall-system-frames-in-scene',
      component: withErrorMessage(getBrorAddingRegularInteriorToWallSystemFrameErrorMessage)(
        ErrorMessageInline
      ),
      hidden: (coreApi: CoreApi) =>
        hideBrorAddingRegularInteriorToWallSystemFrameErrorMessage(coreApi)
    },
    {
      id: 'error-message-no-matching-cabinet-dimensions',
      component: withErrorMessage(getBrorNoMatchingFramesForDrawersErrorMessage)(
        ErrorMessageInline
      ),
      hidden: (coreApi: CoreApi) =>
        hideBrorNoMatchingFramesForDrawersErrorMessage(coreApi) ||
        !hideBrorAddingRegularInteriorToWallSystemFrameErrorMessage(coreApi)
    },
    {
      id: 'change-interior-color',
      component: ChangeColorFilter
    },
    {
      id: 'interiors-product-list',
      component: withProducts(ProductList, interiorsProductListConfig)
    }
  ],
  mobile: [
    {
      id: `interior-color-black`,
      component: BlackInteriorSwiper(withProducts(ProductSwiper, interiorsProductListConfig)),
      title: 'storageone.colorBlack',
      icon: Black,
      iconColor: '#353535'
    },
    {
      id: `interior-color-grey-green`,
      component: GreyGreenInteriorSwiper(withProducts(ProductSwiper, interiorsProductListConfig)),
      title: 'storageone.colorGreyGreen',
      icon: GreyGreen,
      iconColor: '#738273'
    }
  ]
};

const filters = {
  desktop: [],
  mobile: []
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListInteriorsTitle',
  behaviors: {
    productGroupEntered: [],
    productGroupExited: []
  },
  filters: filters[platform],
  widgets: widgets[platform]
};

export default mainMenu;
